<!-- @format -->

<template>
	<pc-container :title="title" class="pc-tree">
		<template #extra>
			<el-button v-if="isShowAddRootNode" type="primary" link icon="Plus" @click="handleAddRootNode"></el-button>
			<slot name="root-node-btn"></slot>
		</template>

		<el-input
			v-if="isShowSearch"
			v-model="searchValue"
			:placeholder="searchPlaceholder || '请输入查询条件'"
			clearable
			@keyup.enter="onFilter"
		/>

		<el-tree
			ref="treeRef"
			class="pc-tree-warp"
			:data="data"
			:filter-node-method="filterNode"
			:node-key="nodeKey"
			highlight-current
			v-bind="$attrs"
			:props="props.props"
		>
			<template #default="{ data }">
				<span class="custom-tree-node" @mouseover="hoverItemId = data[nodeKey]" @mouseleave="hoverItemId = ''">
					<span class="custom-tree-node-label">
						<span class="custom-tree-node-label-img">
							<slot name="node-label-icon" v-bind="data"></slot>
						</span>
						<slot name="node-label" v-bind="data">
							{{ data[props.props.label] }}
						</slot>
					</span>
					<span v-if="data[nodeKey] === hoverItemId" class="custom-tree-node-utils">
						<slot name="node-btn-before" v-bind="data"></slot>
						<slot v-if="showBtn('add', data)" name="add-node" v-bind="data">
							<el-tooltip content="新增" placement="top" :show-after="500">
								<el-button icon="Plus" type="primary" link @click.stop="() => handleClickNode('add', data)" />
							</el-tooltip>
						</slot>
						<slot v-if="showBtn('edit', data)" name="edit-node" v-bind="data">
							<el-tooltip content="编辑" placement="top" :show-after="500">
								<el-button icon="Edit" type="primary" link @click.stop="() => handleClickNode('edit', data)" />
							</el-tooltip>
						</slot>
						<slot v-if="showBtn('delete', data)" name="delete-node" v-bind="data">
							<el-tooltip content="删除" placement="top" :show-after="500">
								<el-button icon="Delete" type="primary" link @click.stop="() => handleClickNode('delete', data)" />
							</el-tooltip>
						</slot>
						<slot name="node-btn-after" v-bind="data"></slot>
					</span>
				</span>
			</template>
		</el-tree>
	</pc-container>
</template>

<script lang="ts" setup>
	import { type ElTree } from 'element-plus';
	import { PcContainer } from '@/components';

	interface Props {
		title?: string;
		isShowAddRootNode?: boolean;
		isShowSearch?: boolean;
		searchPlaceholder?: string;
		remoteSearchMethod?: Function;
		filterNodeMethod?: Function;
		data: any;
		props?: any;
		nodeKey: string;
		showAddBtn?: Function;
		showEditBtn?: Function;
		showDeleteBtn?: Function;
	}

	const emits = defineEmits(['handleAddRootNode', 'handleNodeBtn']);
	const props = withDefaults(defineProps<Props>(), {
		isShowAddRootNode: false,
		isShowSearch: false,
		props: {
			children: 'children',
			label: 'label',
		},
		searchPlaceholder: '',
	});

	const treeRef = ref<InstanceType<typeof ElTree>>();
	const searchValue = ref('');
	const hoverItemId = ref('');

	const data = computed(() => props.data);

	const handleAddRootNode = () => {
		emits('handleAddRootNode');
	};

	const onFilter = () => {
		if (props.remoteSearchMethod) {
			props.remoteSearchMethod(searchValue.value);
		} else {
			treeRef.value!.filter(searchValue.value);
		}
	};

	const filterNode = (value, data, node) => {
		if (!value) return true;
		return props.filterNodeMethod ? props.filterNodeMethod(value, data, node) : true;
	};

	const handleClickNode = (type, data) => {
		emits('handleNodeBtn', type, data);
	};

	const showBtn = (type, data) => {
		if (type === 'add') {
			if (props.showAddBtn) {
				return props.showAddBtn(data);
			} else {
				return false;
			}
		} else if (type === 'edit') {
			if (props.showEditBtn) {
				return props.showEditBtn(data);
			} else {
				return false;
			}
		} else {
			if (props.showDeleteBtn) {
				return props.showDeleteBtn(data);
			} else {
				return false;
			}
		}
	};

	defineExpose({ treeRef });
</script>

<style lang="scss" scoped>
	.pc-tree {
		height: 100%;

		.pc-tree-warp {
			margin-top: 5px;
			height: calc(100% - 40px);
			overflow-y: scroll;

			:deep(.el-tree-node__content) {
				width: 100%;

				.el-tree-node__label {
					width: calc(100% - 24px);
				}
			}

			.custom-tree-node {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: calc(100% - 24px);

				.custom-tree-node-label {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;

					.custom-tree-node-label-img {
						width: 1em;
						height: 1em;
						margin-right: 2px;
						vertical-align: middle;
					}
				}

				.custom-tree-node-utils {
					display: flex;

					.el-button {
						padding: 1px;
					}

					.el-button + .el-button {
						margin-left: 0px;
					}
				}
			}
		}
	}
</style>
